module.exports = __webpack_public_path__ + "img/_Down_Receptor_Go_4x1.6a5930ce.png";